export default __webpack_public_path__ + "cd564f6cc3221485c630d8ba5f1fbc28.png";